import { action } from "typesafe-actions";
import { ThunkAction } from "redux-thunk";
import { IStoreState } from "../../initialStoreState";
import { AnyAction } from "redux";
import { api } from "../../../api/api";
import {
  saveLoaderCompleted,
  saveLoaderProgress,
  showMessage,
} from "../../messages/messagesActions";
import { IHabitationalQuote, initialHabitationalQuoteState } from "./habitationalQuote.types";

export const FETCH_HABITATIONAL_QUOTE_PROGRESS =
  "FETCH_HABITATIONAL_QUOTE_PROGRESS";
export const FETCH_HABITATIONAL_QUOTE_SUCCESSS =
  "FETCH_HABITATIONAL_QUOTE_SUCCESSS";
export const FETCH_HABITATIONAL_QUOTE_FAILED = "FETCH_HABITATIONAL_QUOTE_FAILED";

export const fetchHabitationalQuoteProgress = () =>
  action(FETCH_HABITATIONAL_QUOTE_PROGRESS);
export const fetchHabitationalQuoteSuccess = (data: IHabitationalQuote) =>
  action(FETCH_HABITATIONAL_QUOTE_SUCCESSS, { data });
export const fetchHabitationalQuoteFailed = () =>
  action(FETCH_HABITATIONAL_QUOTE_FAILED);

export const fetchhHabitationalQuoteAsync =
  (
	customerPolicyId: number,
	incremental_number: number
  ): ThunkAction<void, IStoreState, {}, AnyAction> =>
  async (dispatch, getState) => {
	try {
	  dispatch(fetchHabitationalQuoteProgress());
	  const res = await api.get(
		`/policy/get-policy-auto-quote?customer_policy_id=${customerPolicyId}&column=incremental_number&value=${incremental_number}`
	  );
	  const data: IHabitationalQuote[] = res.data.data;
	  if (data.length > 0) {
		dispatch(fetchHabitationalQuoteSuccess(data[0]));
	  } else {
		dispatch(
		  fetchHabitationalQuoteSuccess(initialHabitationalQuoteState["data"])
		);
	  }
	} catch (err: any) {
	  dispatch(fetchHabitationalQuoteFailed());
	  dispatch(
		showMessage({
		  type: "error",
		  message: err.response.data.message,
		  displayAs: "snackbar",
		})
	  );
	}
  };

export const addHabitationalQuote =
  (
	data: IHabitationalQuote,
	onCallback: (isSuccess: boolean) => void
  ): ThunkAction<void, IStoreState, {}, AnyAction> =>
  async (dispatch, getState) => {
	try {
	  dispatch(saveLoaderProgress());
	  await api.post("/policy/edit-policy-auto-quote", {
		...data,
	  });
	  onCallback(true);
	  dispatch(
		showMessage({
		  type: "success",
		  message: "Quote saved successfully!",
		  displayAs: "snackbar",
		})
	  );
	  dispatch(fetchHabitationalQuoteSuccess(data));
	} catch (err: any) {
	  onCallback(false);
	  dispatch(
		showMessage({
		  type: "error",
		  message: err.response.data.message,
		  displayAs: "snackbar",
		})
	  );
	} finally {
	  dispatch(saveLoaderCompleted());
	}
  };

export const FETCH_HABITATIONAL_QUOTE_LIST_PROGRESS =
  "FETCH_HABITATIONAL_QUOTE_LIST_PROGRESS";
export const FETCH_HABITATIONAL_QUOTE_LIST_SUCCESS =
  "FETCH_HABITATIONAL_QUOTE_LIST_SUCCESS";
export const FETCH_HABITATIONAL_QUOTE_LIST_FAILED =
  "FETCH_HABITATIONAL_QUOTE_LIST_FAILED";

export const fetchHabitationalQuoteListProgress = () =>
  action(FETCH_HABITATIONAL_QUOTE_LIST_PROGRESS);

export const fetchHabitationalQuotesListSuccess = (data: IHabitationalQuote[]) =>
  action(FETCH_HABITATIONAL_QUOTE_LIST_SUCCESS, {
	data,
  });
export const fetchHabitationalQuoteListFailed = () =>
  action(FETCH_HABITATIONAL_QUOTE_LIST_FAILED);

export const fetchHabitationalQuoteListAsync =
  (
	customerPolicyId: number,
	status?: string
  ): ThunkAction<void, IStoreState, {}, AnyAction> =>
  async (dispatch, getState) => {
	try {
	  dispatch(fetchHabitationalQuoteListProgress());

	  let finalUrl = `/policy/get-policy-auto-quote?customer_policy_id=${customerPolicyId}`;

	  if (status !== undefined && status !== "-1") {
		finalUrl += `&status=${status}`;
	  }
	  const res = await api.get(finalUrl);
	  const data: IHabitationalQuote[] = res.data.data;
	  dispatch(fetchHabitationalQuotesListSuccess(data));
	} catch (err: any) {
	  dispatch(fetchHabitationalQuoteListFailed());
	  dispatch(
		showMessage({
		  type: "error",
		  message: err.response.data.message,
		  displayAs: "snackbar",
		})
	  );
	}
  };

export const CLEAR_HABITATIONAL_QUOTE_STATE =
  "CLEAR_HABITATIONAL_QUOTE_STATE";

export const clearHabitationalQuoteState = () =>
  action(CLEAR_HABITATIONAL_QUOTE_STATE);
